import * as React from "react";
import { Container, makeStyles, Theme } from "@material-ui/core";
import Header from "../Header";
import AppDrawer from "../Drawer";

type Props = {
  paddingTop?: boolean;
  children: React.ReactNode;
};

type styleProps = {
  topPadding: boolean;
};

const useStyle = makeStyles<Theme, styleProps>((theme: Theme) => ({
  main: {
    maxHeight: `calc(100vh - ${theme.mixins.toolbar.minHeight}px - ${theme.spacing(15)}px)`, // WARNING magic number → manual test on big text tooltips overflow (Component/InstallationInformation)
  },
  root: ({ topPadding }) => ({
    backgroundColor: "#F5F5F5",

    [theme.breakpoints.up("sm")]: {
      "paddingLeft": theme.spacing(9),
      "& .children-wrapper": {
        paddingTop: topPadding ? theme.spacing(5) : "unset",
      },
    },

    [theme.breakpoints.down("sm")]: {
      "marginTop": theme.mixins.toolbar.minHeight,
      "& .children-wrapper": {
        paddingTop: topPadding ? theme.spacing(2) : "unset",
      },
    },
  }),
}));

function BaseLayout({ children, paddingTop = false }: Props) {
  const classes = useStyle({ topPadding: paddingTop });

  return (
    <main className={classes.main}>
      <AppDrawer />
      <Container className={classes.root} maxWidth="xl">
        <Header />
        <div className="children-wrapper">{children}</div>
      </Container>
    </main>
  );
}

export default BaseLayout;
